import { createContext } from 'react';
import { Contact } from 'models/Contact';
import utils from 'utils';

type ContactsContextProps = {
  selected: Contact[];
  isAllSelected: boolean;
  isDeleting?: boolean;
  selectAll: () => void;
  removeAll: () => void;
  handleManage: (contacts: Contact[]) => void;
  handleDelete: (contacts: Contact[]) => void;
  updateSelected: (contact: Contact) => void;
  updateSelectedValue: (contact: Contact) => void;
};

export default createContext<Partial<ContactsContextProps>>({
  selected: [],
  isAllSelected: false,
  isDeleting: false,
  handleManage: utils.noop,
  handleDelete: utils.noop,
  selectAll: utils.noop,
  removeAll: utils.noop,
  updateSelected: utils.noop,
  updateSelectedValue: utils.noop,
});
